/**
 * TimeframeSelector — Pill-button row for dashboard date range filtering.
 *
 * Props:
 *   preset        - current preset key ('all_time', 'this_week', etc.)
 *   onPresetChange - callback(presetKey)
 *   customStart   - ISO date string for custom start
 *   customEnd     - ISO date string for custom end
 *   onCustomStartChange - callback(dateString)
 *   onCustomEndChange   - callback(dateString)
 */

import { TIMEFRAME_OPTIONS } from '../hooks/useTimeframe';

const pill = (active) => ({
  padding: '4px 10px',
  fontSize: 10,
  fontFamily: 'var(--font-mono)',
  fontWeight: active ? 600 : 400,
  background: active ? 'rgba(var(--accent-teal-rgb, 59,111,214), 0.1)' : 'transparent',
  color: active ? 'var(--accent-teal)' : 'var(--text-muted)',
  border: `1px solid ${active ? 'rgba(var(--accent-teal-rgb, 59,111,214), 0.25)' : 'var(--border)'}`,
  borderRadius: 4,
  cursor: 'pointer',
  whiteSpace: 'nowrap',
  transition: 'all 0.15s',
});

const dateInput = {
  padding: '3px 6px',
  fontSize: 10,
  fontFamily: 'var(--font-mono)',
  background: 'var(--bg-input)',
  color: 'var(--text-primary)',
  border: '1px solid var(--border)',
  borderRadius: 4,
  outline: 'none',
};

export default function TimeframeSelector({ preset, onPresetChange, customStart, customEnd, onCustomStartChange, onCustomEndChange }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 4, flexWrap: 'wrap' }}>
      {TIMEFRAME_OPTIONS.map(opt => (
        <button
          key={opt.key}
          onClick={() => onPresetChange(opt.key)}
          style={pill(preset === opt.key)}
        >
          {opt.label}
        </button>
      ))}
      {preset === 'custom' && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 4, marginLeft: 4 }}>
          <input
            type="date"
            value={customStart}
            onChange={e => onCustomStartChange(e.target.value)}
            style={dateInput}
          />
          <span style={{ fontSize: 9, color: 'var(--text-muted)' }}>to</span>
          <input
            type="date"
            value={customEnd}
            onChange={e => onCustomEndChange(e.target.value)}
            style={dateInput}
          />
        </div>
      )}
    </div>
  );
}
